"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _detectEmojiSupport = _interopRequireDefault(require("detect-emoji-support"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var emojisSupported = (0, _detectEmojiSupport["default"])();
var APPhoneInputFlags = function APPhoneInputFlags(props) {
  var country = props.country;
  var flag = country.toUpperCase().replace(/./g, function (_char) {
    return String.fromCodePoint(_char.charCodeAt(0) + 127397);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "react-phone-number-input__icon"
  }, emojisSupported ? flag : country);
};
APPhoneInputFlags.defaultProps = {
  country: ''
};
APPhoneInputFlags.propTypes = {
  country: _propTypes["default"].string
};
var _default = exports["default"] = APPhoneInputFlags;